import {
  CLAIMS_PROCESSED_LOADING,
  CLAIMS_PROCESSED_SUCCESS,
  CLAIMS_PROCESSED_FAILURE,
  CLAIMS_METRICS_EXCLUSION_LOADING,
  CLAIMS_METRICS_EXCLUSION_SUCCESS,
  CLAIMS_METRICS_EXCLUSION_FAILURE,
  DOP_CLAIMS_METRICS_CLAIMS_LOADING,
  DOP_CLAIMS_METRICS_CLAIMS_SUCCESS,
  DOP_CLAIMS_METRICS_CLAIMS_FAILURE,
  DOP_CLAIMS_METRICS_TAT_LOADING,
  DOP_CLAIMS_METRICS_TAT_SUCCESS,
  DOP_CLAIMS_METRICS_TAT_FAILURE,
  CLAIMS_PROCESSED_MONTHLY_LOADING,
  CLAIMS_PROCESSED_MONTHLY_SUCCESS,
  CLAIMS_PROCESSED_MONTHLY_FAILURE,
  CLAIMS_PROCESSED_LOB_LOADING,
  CLAIMS_PROCESSED_LOB_SUCCESS,
  CLAIMS_PROCESSED_LOB_FAILURE,
} from '../../../actions/actionTypes';

interface ClaimsProcessedState {
  claimsProcessedData: any;
  claimsProcessedIsLoading: boolean;
  claimsProcessedError: boolean;
  claimsMetricsExclusionData: any;
  claimsMetricsExclusionIsLoading: boolean;
  claimsMetricsExclusionError: boolean;
  dopClaimsMetricsClaimsData: any;
  dopClaimsMetricsClaimsIsLoading: boolean;
  dopClaimsMetricsClaimsError: boolean;
  dopClaimsMetricsTatData: any;
  dopClaimsMetricsTatIsLoading: boolean;
  dopClaimsMetricsTatError: boolean;
  claimsProcessedMonthlyData: any;
  claimsProcessedMonthlyIsLoading: boolean;
  claimsProcessedMonthlyError: boolean;
  claimsProcessedLobData: any;
  claimsProcessedLobIsLoading: boolean;
  claimsProcessedLobError: boolean;
}

const initialState: ClaimsProcessedState = {
  claimsProcessedData: {},
  claimsProcessedIsLoading: false,
  claimsProcessedError: false,
  claimsMetricsExclusionData: {},
  claimsMetricsExclusionIsLoading: false,
  claimsMetricsExclusionError: false,
  dopClaimsMetricsClaimsData: {},
  dopClaimsMetricsClaimsIsLoading: false,
  dopClaimsMetricsClaimsError: false,
  dopClaimsMetricsTatData: {},
  dopClaimsMetricsTatIsLoading: false,
  dopClaimsMetricsTatError: false,
  claimsProcessedMonthlyData: {},
  claimsProcessedMonthlyIsLoading: false,
  claimsProcessedMonthlyError: false,
  claimsProcessedLobData: [],
  claimsProcessedLobIsLoading: false,
  claimsProcessedLobError: false,
};

const ClaimsProcessedReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): ClaimsProcessedState => {
  switch (action.type) {
    case CLAIMS_PROCESSED_LOADING:
      return {
        ...state,
        claimsProcessedIsLoading: action.payload,
      };

    case CLAIMS_PROCESSED_SUCCESS:
      return {
        ...state,
        claimsProcessedData: action.payload,
      };

    case CLAIMS_PROCESSED_FAILURE:
      return {
        ...state,
        claimsProcessedError: action.payload,
      };

    case CLAIMS_METRICS_EXCLUSION_LOADING:
      return {
        ...state,
        claimsMetricsExclusionIsLoading: action.payload,
      };

    case CLAIMS_METRICS_EXCLUSION_SUCCESS:
      return {
        ...state,
        claimsMetricsExclusionData: action.payload,
      };

    case CLAIMS_METRICS_EXCLUSION_FAILURE:
      return {
        ...state,
        claimsMetricsExclusionError: action.payload,
      };

    case DOP_CLAIMS_METRICS_CLAIMS_LOADING:
      return {
        ...state,
        dopClaimsMetricsClaimsIsLoading: action.payload,
      };

    case DOP_CLAIMS_METRICS_CLAIMS_SUCCESS:
      return {
        ...state,
        dopClaimsMetricsClaimsData: action.payload,
      };

    case DOP_CLAIMS_METRICS_CLAIMS_FAILURE:
      return {
        ...state,
        dopClaimsMetricsClaimsError: action.payload,
      };

    case DOP_CLAIMS_METRICS_TAT_LOADING:
      return {
        ...state,
        dopClaimsMetricsTatIsLoading: action.payload,
      };

    case DOP_CLAIMS_METRICS_TAT_SUCCESS:
      return {
        ...state,
        dopClaimsMetricsTatData: action.payload,
      };

    case DOP_CLAIMS_METRICS_TAT_FAILURE:
      return {
        ...state,
        dopClaimsMetricsTatError: action.payload,
      };

    case CLAIMS_PROCESSED_MONTHLY_LOADING:
      return {
        ...state,
        claimsProcessedMonthlyIsLoading: action.payload,
      };

    case CLAIMS_PROCESSED_MONTHLY_SUCCESS:
      return {
        ...state,
        claimsProcessedMonthlyData: action.payload,
      };

    case CLAIMS_PROCESSED_MONTHLY_FAILURE:
      return {
        ...state,
        claimsProcessedMonthlyError: action.payload,
      };

    case CLAIMS_PROCESSED_LOB_LOADING:
      return {
        ...state,
        claimsProcessedLobIsLoading: action.payload,
      };

    case CLAIMS_PROCESSED_LOB_SUCCESS:
      return {
        ...state,
        claimsProcessedLobData: action.payload,
      };

    case CLAIMS_PROCESSED_LOB_FAILURE:
      return {
        ...state,
        claimsProcessedLobError: action.payload,
      };
      
    default:
      return state;
  }
};

export default ClaimsProcessedReducer;
